import { WeatherTileContent } from '../models/commonTypeScript';
import fetch from './fetch';
import getFetchHeaders from './getFetchHeaders';

export default async (locationId: string): Promise<WeatherTileContent> =>
    fetch<WeatherTileContent>(`/locations/${locationId}/outdoor`, {
        method: 'GET',
        headers: await getFetchHeaders(),
    });
